import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('concepto-universidad'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('concepto-universidad'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`concepto-universidad/${id}`));
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`concepto-universidad/${id}`), data);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`concepto-universidad/${id}`));
  },
  async findAllByProgramaUniversidadId(programaUniversidadId, opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIPagos(`concepto-universidad/programa-universidad/${programaUniversidadId}`),
      {
        params: opciones.params,
      },
    );
  },
  async findAllBySedeId(sedeId, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`concepto-universidad/sedes/${sedeId}`), { params: opciones.params });
  },
};
